import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { Area } from './../../modelos/area';

@Component({
    selector: 'app-cadastro-area',
    templateUrl: './cadastro-area.component.html',
    styleUrls: ['./cadastro-area.component.css']
})
export class CadastroAreaComponent implements OnInit {

    @Output() areaEvent: EventEmitter<Area>;

    public area: Area;

    constructor (private modalService: NgbModal) {
        this.areaEvent = new EventEmitter<Area>();
    }

    cadastrar(content) {

        const ngbModalOptions: NgbModalOptions = {
            backdrop: 'static',
            keyboard: false
        };

        this.area = new Area();
        this.modalService.open(content, ngbModalOptions).result.then((result) => {
            this.areaEvent.emit(this.area);
        }, (reason) => {
        });
    }

    ngOnInit() {
    }
}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/comum/components/cadastro-area/cadastro-area.component.ts